<app-header></app-header>

<div class="max-w-7xl mx-auto px-4 py-6">

  <!-- Cabeçalho -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-xl font-bold text-gray-800 dark:text-gray-100">Painel do Supervisor</h1>
      <p class="text-sm text-gray-500">Status em tempo real e métricas dos operadores</p>
    </div>
    <input *ngIf="tab === 'metrics' || tab === 'peaks' || tab === 'trail'" type="date" [value]="dateRef" (change)="setDate($event)"
      class="border rounded-lg px-3 py-1.5 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none"/>
  </div>

  <!-- Tabs -->
  <div class="flex gap-1 mb-6 bg-gray-100 dark:bg-zinc-800 p-1 rounded-lg w-fit">
    <button *ngFor="let t of [{k:'live',l:'Ao Vivo'},{k:'metrics',l:'Métricas'},{k:'peaks',l:'Picos de Fluxo'},{k:'trail',l:'Rastreio de Senhas'},{k:'windows',l:'Liberar Guichê'}]"
      (click)="setTab($any(t.k))"
      [ngClass]="tab === t.k
        ? 'bg-white dark:bg-zinc-700 shadow text-purple-700 font-semibold'
        : 'text-gray-500 hover:text-gray-700'"
      class="px-4 py-1.5 text-sm rounded-md transition-all">
      {{ t.l }}
    </button>
  </div>

  <div *ngIf="isLoading" class="flex justify-center py-12">
    <div class="w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- AO VIVO -->
  <div *ngIf="tab === 'live' && !isLoading">
    <p class="text-xs text-gray-400 mb-4">Atualiza automaticamente a cada 15 segundos • Operadores com ping nos últimos 2 minutos</p>

    <!-- ── Cards de Resumo da Fila ── -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      <!-- Total aguardando -->
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Aguardando</p>
        <p class="text-3xl font-black text-purple-600">{{ totalWaiting }}</p>
        <p class="text-xs text-gray-400">senhas na fila</p>
      </div>
      <!-- Guichês ativos / pausados / offline -->
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-2">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Guichês</p>
        <div class="flex items-end gap-2">
          <p class="text-3xl font-black text-green-600">{{ activeOperators }}</p>
          <p class="text-xs text-gray-400 mb-1">online</p>
          <p class="text-xs text-gray-400 mb-1">/ {{ todayTotal }} hoje</p>
        </div>
        <div class="flex items-center gap-3 text-xs">
          <span class="flex items-center gap-1">
            <span class="w-2 h-2 rounded-full bg-green-500"></span>
            <span class="text-gray-600 dark:text-gray-300">{{ availableOperators }} ativos</span>
          </span>
          <span class="flex items-center gap-1" [ngClass]="pausedOperators > 0 ? 'text-yellow-600' : 'text-gray-400'">
            <span class="w-2 h-2 rounded-full" [ngClass]="pausedOperators > 0 ? 'bg-yellow-400' : 'bg-gray-300'"></span>
            <span>{{ pausedOperators }} pausados</span>
          </span>
        </div>
      </div>
      <!-- Carga por operador -->
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Carga</p>
        <p class="text-3xl font-black" [ngClass]="loadPerOperator > 10 ? 'text-red-500' : loadPerOperator > 5 ? 'text-yellow-500' : 'text-green-600'">
          {{ activeOperators > 0 ? loadPerOperator : '—' }}
        </p>
        <p class="text-xs text-gray-400">senhas / guichê</p>
      </div>
      <!-- Por grupo -->
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1.5">
        <p class="text-xs text-gray-400 uppercase tracking-wide mb-1">Por grupo</p>
        <div *ngIf="!queueSummary.length" class="text-xs text-gray-400">Fila vazia</div>
        <div *ngFor="let g of queueSummary" class="flex items-center justify-between gap-2">
          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full flex-shrink-0" [ngStyle]="{ 'background-color': groupColor(g.letter) }"></span>
            <span class="text-xs text-gray-600 dark:text-gray-300 truncate max-w-[90px]" [title]="g.queueName">{{ g.letter }}</span>
          </div>
          <span class="text-xs font-bold" [ngStyle]="{ 'color': groupColor(g.letter) }">{{ g.waitingCount }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="!liveStatus.length" class="text-center py-12 text-gray-400">
      Nenhum operador registrou acesso hoje.
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div *ngFor="let s of liveStatus"
        [ngClass]="{
          'border-red-300 bg-red-50': isIdle(s),
          'opacity-50': !s.isOnline,
          'border-gray-200 bg-white': !isIdle(s)
        }"
        class="border rounded-xl p-4 shadow-sm dark:bg-zinc-800 dark:border-zinc-700 flex flex-col gap-3">

        <!-- Cabeçalho do card -->
        <div class="flex items-center justify-between">
          <div>
            <p class="font-semibold text-sm"
               [ngClass]="s.isOnline ? 'text-gray-800 dark:text-gray-100' : 'text-gray-400'">
              {{ s.username }}
            </p>
            <p class="text-xs text-gray-400">{{ s.machine }}</p>
          </div>
          <span class="px-2 py-0.5 rounded-full text-xs font-medium" [ngClass]="statusColor(s)">
            {{ statusLabel(s) }}
          </span>
        </div>

        <!-- Motivo da pausa (só online) -->
        <div *ngIf="s.isOnline && s.cycleStatus === 'PAUSADO' && s.pauseReason"
             class="flex items-center gap-1.5 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 rounded-lg px-3 py-1.5">
          <svg class="w-3.5 h-3.5 text-yellow-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <span class="text-xs text-yellow-700 dark:text-yellow-300 font-medium">{{ s.pauseReason }}</span>
        </div>

        <!-- Dados do atendimento (só online) -->
        <div *ngIf="s.isOnline && s.currentPassword" class="bg-gray-50 dark:bg-zinc-700 rounded-lg p-2 text-xs">
          <p class="font-medium text-gray-700 dark:text-gray-200">{{ s.currentPassword }}
            <span *ngIf="s.currentPatient" class="text-gray-500">— {{ s.currentPatient }}</span>
          </p>
          <p *ngIf="s.attendanceDurationSeconds > 0" class="text-gray-400 mt-0.5">
            Em atendimento há {{ fmtSec(s.attendanceDurationSeconds) }}
          </p>
        </div>

        <!-- Métricas rápidas -->
        <div class="grid grid-cols-3 gap-2 text-center text-xs">
          <div>
            <p class="font-bold text-lg text-purple-600">{{ s.todayAttended }}</p>
            <p class="text-gray-400">atendidos</p>
          </div>
          <div *ngIf="s.isOnline" [ngClass]="s.idleSeconds > 300 ? 'text-red-600' : 'text-gray-600'">
            <p class="font-bold text-lg">{{ fmtSec(s.idleSeconds) }}</p>
            <p class="text-gray-400">ocioso</p>
          </div>
          <div *ngIf="!s.isOnline">
            <p class="font-bold text-lg text-gray-400">—</p>
            <p class="text-gray-400">ocioso</p>
          </div>
          <div>
            <p class="font-bold text-lg text-gray-600">{{ s.loginAt | date:'HH:mm' }}</p>
            <p class="text-gray-400">entrada</p>
          </div>
        </div>

        <!-- Particular / Plano -->
        <div *ngIf="(s.attendedPrivate + s.attendedPlan) > 0"
             class="flex gap-2 text-xs justify-center">
          <span class="px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
            {{ s.attendedPrivate }} particular
          </span>
          <span class="px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
            {{ s.attendedPlan }} plano
          </span>
        </div>

        <!-- Média de atendimento -->
        <div *ngIf="s.avgAttendanceSeconds > 0" class="text-xs text-center text-gray-400">
          Média atend.: <span class="font-medium text-gray-600 dark:text-gray-300">{{ fmtMin(s.avgAttendanceSeconds) }}</span>
        </div>

        <!-- Pausas por motivo (histórico do dia) -->
        <div *ngIf="pauseSummaryForUser(s.username).length > 0"
             class="border-t dark:border-zinc-700 pt-2 flex flex-col gap-1">
          <p class="text-[10px] text-gray-400 uppercase tracking-wide mb-0.5">Pausas hoje</p>
          <div *ngFor="let ps of pauseSummaryForUser(s.username)"
               class="flex justify-between text-xs text-gray-600 dark:text-gray-300">
            <span class="truncate">{{ ps.reason }}</span>
            <span class="font-medium shrink-0 ml-2">{{ fmtMin(ps.totalSec) }}</span>
          </div>
        </div>

        <!-- Caixa do operador (online e offline) -->
        <ng-container *ngIf="caixaOf(s.username) as c">
          <div class="border-t dark:border-zinc-700 pt-2 text-xs flex items-center justify-between gap-2">
            <p class="text-gray-500 dark:text-gray-400 truncate flex-1" [title]="c.name">{{ c.name }}</p>
            <div class="flex items-center gap-1.5 shrink-0">
              <span class="font-semibold text-gray-700 dark:text-gray-200">{{ formatCurrency(c.currentBalance) }}</span>
              <span class="px-1.5 py-0.5 rounded text-[10px] font-bold"
                    [ngClass]="!c.isOpen ? 'bg-gray-100 text-gray-500 dark:bg-zinc-700 dark:text-zinc-400' :
                                caixaPrecisaSangrar(c) ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'">
                {{ !c.isOpen ? 'Fechado' : caixaPrecisaSangrar(c) ? 'Sangrar' : 'OK' }}
              </span>
            </div>
          </div>
        </ng-container>

        <!-- Alerta de ociosidade (só online) -->
        <div *ngIf="isIdle(s)" class="text-xs bg-red-100 text-red-700 rounded px-2 py-1 text-center font-medium">
          ⚠️ Ocioso há mais de 10 min — verificar
        </div>
      </div>
    </div>
  </div>

  <!-- MÉTRICAS -->
  <div *ngIf="tab === 'metrics' && !isLoading">
    <div *ngIf="!metrics.length" class="text-center py-12 text-gray-400">Sem dados para a data selecionada.</div>

    <div class="overflow-x-auto rounded-xl border dark:border-zinc-700 shadow-sm">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-zinc-800 text-gray-500 text-xs uppercase">
          <tr>
            <th class="px-4 py-3 text-left">Operador</th>
            <th class="px-4 py-3 text-left">Guichê</th>
            <th class="px-4 py-3 text-center">Atendidos</th>
            <th class="px-4 py-3 text-center">Particular</th>
            <th class="px-4 py-3 text-center">Plano</th>
            <th class="px-4 py-3 text-center">Não atend.</th>
            <th class="px-4 py-3 text-center">Descartados</th>
            <th class="px-4 py-3 text-center">Média contagem</th>
            <th class="px-4 py-3 text-center">Média atend.</th>
            <th class="px-4 py-3 text-center">Ocioso total</th>
            <th class="px-4 py-3 text-center">Pausado total</th>
            <th class="px-4 py-3 text-center">Logins</th>
            <th class="px-4 py-3 text-center">Saídas</th>
            <th class="px-4 py-3 text-center">Meta</th>
          </tr>
        </thead>
        <tbody class="divide-y dark:divide-zinc-700">
          <tr *ngFor="let m of metrics" class="hover:bg-gray-50 dark:hover:bg-zinc-700 transition-colors">
            <td class="px-4 py-3 font-medium text-gray-800 dark:text-gray-200">{{ m.username }}</td>
            <td class="px-4 py-3 text-xs">
              <div class="flex flex-wrap gap-1">
                <span
                  *ngFor="let g of splitMachines(m.machine)"
                  class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 whitespace-nowrap"
                >{{ g }}</span>
              </div>
            </td>
            <td class="px-4 py-3 text-center font-bold text-purple-600">{{ m.attendedCount }}</td>
            <td class="px-4 py-3 text-center font-semibold text-blue-600">{{ m.attendedPrivate }}</td>
            <td class="px-4 py-3 text-center font-semibold text-teal-600">{{ m.attendedPlan }}</td>
            <td class="px-4 py-3 text-center text-red-500">{{ m.notAttendedCount }}</td>
            <td class="px-4 py-3 text-center text-gray-400">{{ m.discardedCount }}</td>
            <td class="px-4 py-3 text-center text-blue-500">{{ fmtSec(m.avgCountdownSeconds) }}</td>
            <td class="px-4 py-3 text-center text-green-600">{{ fmtSec(m.avgAttendanceSeconds) }}</td>
            <td class="px-4 py-3 text-center" [ngClass]="m.totalIdleSeconds > 3600 ? 'text-red-500' : 'text-gray-500'">
              {{ fmtSecLong(m.totalIdleSeconds) }}
            </td>
            <td class="px-4 py-3 text-center" [ngClass]="m.totalPausedSeconds > 1800 ? 'text-yellow-600 font-semibold' : 'text-gray-500'">
              {{ m.totalPausedSeconds > 0 ? fmtSecLong(m.totalPausedSeconds) : '—' }}
            </td>
            <td class="px-4 py-3 text-center text-gray-600 dark:text-gray-300">{{ m.loginCount }}</td>
            <td class="px-4 py-3 text-center"
                [ngClass]="m.sessionEndCount > 6 ? 'text-orange-600 font-semibold' : 'text-gray-600 dark:text-gray-300'"
                [title]="m.sessionEndCount > 6 ? 'Muitas saídas de sessão — possível logoff no lugar da pausa' : ''">
              {{ m.sessionEndCount }}
            </td>
            <td class="px-4 py-3">
              <div class="flex items-center gap-2">
                <div class="flex-1 bg-gray-200 rounded-full h-1.5">
                  <div class="h-1.5 rounded-full transition-all"
                    [style.width.%]="targetPct(m)"
                    [ngClass]="targetPct(m) >= 100 ? 'bg-green-500' : targetPct(m) >= 70 ? 'bg-yellow-400' : 'bg-red-400'">
                  </div>
                </div>
                <span class="text-xs whitespace-nowrap">{{ targetPct(m) }}%</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Histórico de Pausas -->
    <div *ngIf="pauseHistory.length" class="mt-6">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-yellow-400"></span>
          Histórico de Pausas do Dia
        </h2>
        <select [(ngModel)]="pauseFilterUser"
          class="border rounded-lg px-3 py-1.5 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-800 dark:border-zinc-600 dark:text-gray-200">
          <option value="">Todos os colaboradores</option>
          <option *ngFor="let u of pauseOperators" [value]="u">{{ u }}</option>
        </select>
      </div>

      <div class="flex flex-col gap-4">
        <div *ngFor="let group of pausesByOperator()"
             class="rounded-xl border dark:border-zinc-700 overflow-hidden shadow-sm">

          <!-- Cabeçalho do operador -->
          <div class="flex items-center justify-between px-4 py-2 bg-gray-50 dark:bg-zinc-800 border-b dark:border-zinc-700">
            <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{ group.username }}</span>
            <span class="text-xs text-yellow-600 font-medium">
              {{ group.pauses.length }} pausa{{ group.pauses.length !== 1 ? 's' : '' }} •
              total {{ fmtSecLong(totalPausedByOperator(group.username)) }}
            </span>
          </div>

          <!-- Linhas de pausas -->
          <table class="w-full text-xs">
            <thead class="bg-white dark:bg-zinc-900 text-gray-400 uppercase">
              <tr>
                <th class="px-4 py-2 text-left">Motivo</th>
                <th class="px-4 py-2 text-center">Início</th>
                <th class="px-4 py-2 text-center">Fim</th>
                <th class="px-4 py-2 text-center">Duração</th>
              </tr>
            </thead>
            <tbody class="divide-y dark:divide-zinc-700">
              <tr *ngFor="let p of group.pauses"
                  class="bg-white dark:bg-zinc-800 hover:bg-yellow-50 dark:hover:bg-zinc-700 transition-colors">
                <td class="px-4 py-2 text-gray-700 dark:text-gray-300 font-medium">{{ p.pauseReason }}</td>
                <td class="px-4 py-2 text-center text-gray-500">{{ fmtHour(p.startedAt) }}</td>
                <td class="px-4 py-2 text-center text-gray-500">{{ p.finishedAt ? fmtHour(p.finishedAt) : '—' }}</td>
                <td class="px-4 py-2 text-center"
                    [ngClass]="p.durationSeconds && p.durationSeconds > 600 ? 'text-yellow-600 font-semibold' : 'text-gray-500'">
                  {{ p.durationSeconds ? fmtSec(p.durationSeconds) : '—' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Histórico de Sessões (login/saída) -->
    <div *ngIf="sessionHistory.length" class="mt-6">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2 mb-3">
        <span class="w-2 h-2 rounded-full" [style.background]="'var(--brand-primary)'"></span>
        Histórico de Sessões do Dia
      </h2>

      <div class="flex flex-col gap-4">
        <div *ngFor="let group of sessionsByOperator()"
             class="rounded-xl border dark:border-zinc-700 overflow-hidden shadow-sm">

          <div (click)="toggleSessionUser(group.username)"
               class="flex items-center justify-between px-4 py-2 bg-gray-50 dark:bg-zinc-800 cursor-pointer hover:bg-gray-100 dark:hover:bg-zinc-700 transition-colors"
               [ngClass]="isSessionUserExpanded(group.username) ? 'border-b dark:border-zinc-700' : ''">
            <span class="text-sm font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                   stroke="currentColor" class="w-3.5 h-3.5 text-gray-400 transition-transform"
                   [ngClass]="isSessionUserExpanded(group.username) ? 'rotate-90' : ''">
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
              {{ group.username }}
            </span>
            <span class="text-xs font-medium"
                  [ngClass]="group.ends > 6 ? 'text-orange-600' : 'text-gray-500 dark:text-gray-400'">
              {{ group.logins }} login{{ group.logins !== 1 ? 's' : '' }} •
              {{ group.ends }} saída{{ group.ends !== 1 ? 's' : '' }} •
              <span class="text-gray-400 dark:text-gray-500">{{ group.navs }} navegaç{{ group.navs !== 1 ? 'ões' : 'ão' }}</span>
            </span>
          </div>

          <table *ngIf="isSessionUserExpanded(group.username)" class="w-full text-xs">
            <thead class="bg-white dark:bg-zinc-900 text-gray-400 uppercase">
              <tr>
                <th class="px-4 py-2 text-left">Evento</th>
                <th class="px-4 py-2 text-center">Hora</th>
                <th class="px-4 py-2 text-left">Máquina</th>
              </tr>
            </thead>
            <tbody class="divide-y dark:divide-zinc-700">
              <tr *ngFor="let e of group.events"
                  class="bg-white dark:bg-zinc-800 hover:bg-gray-50 dark:hover:bg-zinc-700 transition-colors">
                <td class="px-4 py-2 font-medium" [ngClass]="sessionEventColor(e)">
                  {{ sessionEventLabel(e) }}
                </td>
                <td class="px-4 py-2 text-center text-gray-500">{{ fmtHourSec(e.occurredAt) }}</td>
                <td class="px-4 py-2 text-gray-500">{{ e.machine || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="metrics.length && !pauseHistory.length"
         class="mt-4 text-xs text-gray-400 text-center">
      Nenhuma pausa registrada nesta data.
    </div>
  </div>

  <!-- LIBERAR GUICHÊ -->
  <!-- RASTREIO DE SENHAS -->
  <div *ngIf="tab === 'trail' && !isLoading">
    <div class="flex items-center gap-3 mb-4">
      <input type="text" [(ngModel)]="trailFilter" placeholder="Buscar senha (ex.: E147)"
             (keyup.enter)="buscarTrail()"
             class="border rounded-lg px-3 py-1.5 text-sm w-52 focus:ring-2 focus:outline-none dark:bg-zinc-800 dark:border-zinc-600 dark:text-gray-200"
             [style.--tw-ring-color]="'var(--brand-primary)'" />
      <button (click)="buscarTrail()"
              class="px-4 py-1.5 rounded-lg text-sm font-medium text-white hover:opacity-90 transition-opacity"
              [style.background]="'var(--brand-primary)'">
        Buscar
      </button>
      <span *ngIf="trailLoaded" class="text-xs text-gray-400">{{ trailFiltered.length }} senha{{ trailFiltered.length !== 1 ? 's' : '' }} no dia</span>
    </div>

    <div *ngIf="!trailLoaded" class="text-center py-12 text-gray-400">
      Digite uma senha para filtrar ou clique em Buscar para listar todas as senhas do dia.
    </div>

    <div *ngIf="trailLoaded && !trail.length" class="text-center py-12 text-gray-400">Sem senhas para a data selecionada.</div>

    <div *ngIf="trail.length" class="overflow-x-auto rounded-xl border dark:border-zinc-700 shadow-sm">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-zinc-800 text-gray-500 text-xs uppercase">
          <tr>
            <th class="px-4 py-3 text-left">Senha</th>
            <th class="px-4 py-3 text-left">Paciente</th>
            <th class="px-4 py-3 text-left">Fila</th>
            <th class="px-4 py-3 text-center">Gerada</th>
            <th class="px-4 py-3 text-center">Aberto via</th>
            <th class="px-4 py-3 text-center">Chamadas</th>
            <th class="px-4 py-3 text-center">Último guichê</th>
            <th class="px-4 py-3 text-left">Chamada por</th>
            <th class="px-4 py-3 text-center">Status</th>
          </tr>
        </thead>
        <tbody class="divide-y dark:divide-zinc-700">
          <tr *ngFor="let t of trailFiltered"
              (click)="openTimeline(t)"
              class="cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-zinc-700"
              [ngClass]="selectedTrail?.passwordId === t.passwordId ? 'bg-gray-100 dark:bg-zinc-700' : ''">
            <td class="px-4 py-3">
              <span class="font-bold" [style.color]="'var(--brand-primary)'">{{ t.password }}</span>
              <span *ngIf="t.generatedBy" class="block text-[10px] text-gray-400 font-normal">{{ geradaPorLabel(t.generatedBy) }}</span>
            </td>
            <td class="px-4 py-3">
              <span class="text-gray-700 dark:text-gray-200 text-xs">{{ t.patientName ?? '—' }}</span>
              <span *ngIf="t.personId" class="block text-[10px] text-gray-400">cód. {{ t.personId }}</span>
            </td>
            <td class="px-4 py-3 text-gray-600 dark:text-gray-300">{{ t.queueName }}</td>
            <td class="px-4 py-3 text-center text-gray-500">{{ fmtHourSec(t.generatedAt) }}</td>
            <td class="px-4 py-3 text-center">
              <span *ngIf="t.openingChannel" class="px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-600 dark:bg-zinc-700 dark:text-gray-300">
                {{ channelLabel(t.openingChannel) }}
              </span>
              <span *ngIf="!t.openingChannel && geradorSistema(t.generatedBy)"
                    class="px-2 py-0.5 rounded text-xs bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-300">
                {{ geradaPorLabel(t.generatedBy) }}
              </span>
              <span *ngIf="!t.openingChannel && !geradorSistema(t.generatedBy) && t.discardReason"
                    class="px-2 py-0.5 rounded text-xs bg-red-50 text-red-500 dark:bg-red-900/30 dark:text-red-300">
                Descartada
              </span>
              <span *ngIf="!t.openingChannel && !geradorSistema(t.generatedBy) && !t.discardReason" class="text-gray-400 text-xs">—</span>
            </td>
            <td class="px-4 py-3 text-center font-semibold"
                [ngClass]="t.callCount > 2 ? 'text-orange-600' : 'text-gray-700 dark:text-gray-200'">
              {{ t.callCount }}
            </td>
            <td class="px-4 py-3 text-center text-gray-500">{{ t.lastTicketWindowName ?? t.lastTicketWindowId ?? '—' }}</td>
            <td class="px-4 py-3 text-gray-600 dark:text-gray-300 text-xs">{{ t.lastCalledBy ?? '—' }}</td>
            <td class="px-4 py-3 text-center">
              <span class="px-2 py-0.5 rounded text-xs font-medium" [ngClass]="trailStatusColor(t)">
                {{ trailStatusLabel(t) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Linha do tempo da senha selecionada -->
    <div *ngIf="selectedTrail" class="mt-6">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-200 flex items-center gap-2 mb-3">
        <span class="w-2 h-2 rounded-full" [style.background]="'var(--brand-primary)'"></span>
        Linha do tempo — {{ selectedTrail.password }}
      </h2>

      <div *ngIf="timelineLoading" class="text-center py-6 text-gray-400 text-sm">Carregando…</div>

      <div *ngIf="!timelineLoading" class="rounded-xl border dark:border-zinc-700 shadow-sm bg-white dark:bg-zinc-800 px-4 py-2">
        <div *ngIf="!timeline.length" class="text-center py-6 text-gray-400 text-sm">
          Sem eventos registrados para esta senha (senha anterior à trilha de eventos).
        </div>
        <div *ngFor="let item of timelineView; let last = last"
             class="flex items-start gap-3 py-2"
             [ngClass]="!last ? 'border-b dark:border-zinc-700' : ''">
          <span class="text-xs text-gray-400 w-16 shrink-0 pt-0.5">{{ fmtHourSec(item.e.occurredAt) }}</span>
          <span class="shrink-0 mt-0.5 w-4 h-4" [ngSwitch]="item.icon">
            <svg *ngSwitchCase="'ticket'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-4 h-4" [style.color]="'var(--brand-primary)'">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-1.5h5.25m-5.25-3h5.25M3.75 5.25h16.5c.621 0 1.125.504 1.125 1.125v3.026a2.999 2.999 0 0 0 0 5.198v3.026c0 .621-.504 1.125-1.125 1.125H3.75A1.125 1.125 0 0 1 2.625 17.625v-3.026a2.999 2.999 0 0 0 0-5.198V6.375c0-.621.504-1.125 1.125-1.125Z"/>
            </svg>
            <svg *ngSwitchCase="'bell'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-4 h-4 text-green-600">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"/>
            </svg>
            <svg *ngSwitchCase="'med'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-4 h-4 text-pink-500">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
            </svg>
            <svg *ngSwitchCase="'doc'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-4 h-4 text-blue-500">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
            </svg>
            <svg *ngSwitchCase="'check'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-green-600">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
            </svg>
            <span *ngSwitchDefault class="block w-2 h-2 mt-1 rounded-full bg-gray-400"></span>
          </span>
          <span class="text-sm text-gray-700 dark:text-gray-200">
            <span class="font-medium">{{ item.titulo }}</span>
            <ng-container *ngIf="item.destaqueSala; else localNormal">
              <span class="font-medium text-pink-600"> · {{ item.maquina }}<ng-container *ngIf="item.e.username"> · {{ item.e.username }}</ng-container></span>
            </ng-container>
            <ng-template #localNormal>
              <span *ngIf="item.e.ticketWindowId" class="text-gray-500"> · {{ item.e.ticketWindowName ?? ('guichê ' + item.e.ticketWindowId) }}</span>
              <span *ngIf="item.e.username" class="text-gray-500"> · {{ item.e.username }}</span>
            </ng-template>
            <span *ngIf="item.extra" class="text-gray-400 text-xs"> · {{ item.extra }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="tab === 'windows' && !isLoading">
    <p class="text-xs text-gray-400 mb-4">
      Um guichê fica reservado por 1 hora após o login e não aparece para outros usuários.
      Use <span class="font-medium text-gray-500 dark:text-gray-300">Liberar guichê</span> quando o operador não conseguir entrar (queda de energia, sessão presa, troca de turno).
    </p>

    <!-- ── Cards de Resumo ── -->
    <div class="grid grid-cols-3 gap-3 mb-6">
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Guichês</p>
        <p class="text-3xl font-black text-purple-600">{{ ticketWindows.length }}</p>
        <p class="text-xs text-gray-400">ativos na unidade</p>
      </div>
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Online</p>
        <p class="text-3xl font-black text-green-600">{{ onlineWindows }}</p>
        <p class="text-xs text-gray-400">com ping nos últimos 2 min</p>
      </div>
      <div class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl p-4 shadow-sm flex flex-col gap-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide">Reservados</p>
        <p class="text-3xl font-black" [ngClass]="lockedWindows > 0 ? 'text-orange-500' : 'text-gray-400'">{{ lockedWindows }}</p>
        <p class="text-xs text-gray-400">indisponíveis para login</p>
      </div>
    </div>

    <div *ngIf="!ticketWindows.length" class="text-center py-12 text-gray-400">
      Nenhum guichê ativo encontrado nesta unidade.
    </div>

    <div *ngIf="ticketWindows.length" class="overflow-x-auto rounded-xl border dark:border-zinc-700 shadow-sm">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-zinc-800 text-gray-500 text-xs uppercase">
          <tr>
            <th class="px-4 py-3 text-left">Guichê</th>
            <th class="px-4 py-3 text-center">Código</th>
            <th class="px-4 py-3 text-center">Conexão</th>
            <th class="px-4 py-3 text-left">Reserva de login</th>
            <th class="px-4 py-3 text-center">Ação</th>
          </tr>
        </thead>
        <tbody class="divide-y dark:divide-zinc-700">
          <tr *ngFor="let w of ticketWindows"
              class="transition-colors"
              [ngClass]="releasedWindow === w.name ? 'bg-green-50 dark:bg-green-900/20' : 'hover:bg-gray-50 dark:hover:bg-zinc-700'">
            <td class="px-4 py-3 font-medium text-gray-800 dark:text-gray-200">{{ w.name || '—' }}</td>
            <td class="px-4 py-3 text-center text-gray-500 text-xs">{{ w.ticketWindowId || '—' }}</td>
            <td class="px-4 py-3 text-center">
              <span class="px-2 py-0.5 rounded-full text-xs font-medium inline-flex items-center gap-1.5"
                    [ngClass]="w.isOnline ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-400 dark:bg-zinc-700 dark:text-zinc-400'">
                <span class="w-2 h-2 rounded-full" [ngClass]="w.isOnline ? 'bg-green-500' : 'bg-gray-300'"></span>
                {{ w.isOnline ? 'Online' : 'Offline' }}
              </span>
            </td>
            <td class="px-4 py-3">
              <div *ngIf="w.isLocked" class="flex flex-col">
                <span class="text-xs font-semibold text-orange-600">Reservado por {{ w.lockedByUser }}</span>
                <span class="text-[11px] text-gray-400">até {{ fmtHour(w.lockedUntil!) }}</span>
              </div>
              <span *ngIf="!w.isLocked && releasedWindow !== w.name" class="text-xs text-gray-400">Livre para login</span>
              <span *ngIf="!w.isLocked && releasedWindow === w.name"
                    class="text-xs font-semibold text-green-700 dark:text-green-400 inline-flex items-center gap-1">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                </svg>
                Liberado — já pode logar
              </span>
            </td>
            <td class="px-4 py-3 text-center">
              <button (click)="releaseWindow(w)"
                [disabled]="releasingWindow === w.name"
                title="Essa opção libera o guichê para login"
                class="px-3 py-1.5 text-xs font-semibold rounded-lg transition-all inline-flex items-center gap-1.5
                       disabled:cursor-not-allowed"
                [ngClass]="releasedWindow === w.name
                  ? 'bg-green-600 text-white hover:bg-green-700'
                  : 'bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50'">
                <span *ngIf="releasingWindow === w.name"
                      class="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <svg *ngIf="releasingWindow !== w.name && releasedWindow === w.name"
                     class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                </svg>
                {{ releasingWindow === w.name ? 'Liberando...' : releasedWindow === w.name ? 'Liberado' : 'Liberar guichê' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PICOS DE FLUXO -->
  <div *ngIf="tab === 'peaks' && !isLoading">
    <div *ngIf="!peaks.length" class="text-center py-12 text-gray-400">Sem dados para a data selecionada.</div>

    <div class="grid grid-cols-1 gap-3">
      <div *ngFor="let p of peaks" class="flex items-center gap-4 bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl px-4 py-3 shadow-sm">

        <div class="w-12 text-center">
          <p class="text-lg font-bold text-gray-700 dark:text-gray-200">{{ p.hour }}h</p>
        </div>

        <div class="flex-1">
          <div class="flex items-center gap-2 mb-1">
            <div class="flex-1 bg-gray-100 dark:bg-zinc-700 rounded-full h-3">
              <div class="h-3 rounded-full bg-purple-500 transition-all" [style.width.%]="peakBar(p)"></div>
            </div>
            <span class="text-sm font-semibold text-gray-700 dark:text-gray-200 w-16 text-right">
              {{ p.passwordCount }} senhas
            </span>
          </div>
          <div class="flex gap-4 text-xs text-gray-500">
            <span>👥 {{ p.operatorsOnline }} operadores online</span>
            <span>⏱ Espera média: {{ p.avgWaitMinutes | number:'1.0-0' }} min</span>
            <span *ngIf="p.operatorsOnline > 0 && p.passwordCount / p.operatorsOnline > 10"
              class="text-red-500 font-medium">
              ⚠️ Alta demanda — {{ (p.passwordCount / p.operatorsOnline) | number:'1.0-0' }} senhas/operador
            </span>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<!-- Toast de feedback (fixo, visível em qualquer ponto da rolagem) -->
<div *ngIf="mensagem"
     class="fixed bottom-6 right-6 z-50 flex items-start gap-3 max-w-sm rounded-xl border-l-4 px-4 py-3 shadow-xl"
     [ngClass]="mensagemTipo === 'ok'  ? 'bg-white dark:bg-zinc-800 border-green-500' :
                mensagemTipo === 'err' ? 'bg-white dark:bg-zinc-800 border-red-500' :
                                         'bg-white dark:bg-zinc-800 border-blue-500'">

  <!-- Ícone -->
  <div class="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
       [ngClass]="mensagemTipo === 'ok'  ? 'bg-green-100 text-green-600' :
                  mensagemTipo === 'err' ? 'bg-red-100 text-red-600' :
                                           'bg-blue-100 text-blue-600'">
    <svg *ngIf="mensagemTipo === 'ok'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
    </svg>
    <svg *ngIf="mensagemTipo === 'err'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12"/>
    </svg>
    <svg *ngIf="mensagemTipo === 'info'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
  </div>

  <div class="flex-1 min-w-0">
    <p class="text-sm font-semibold"
       [ngClass]="mensagemTipo === 'ok'  ? 'text-green-700 dark:text-green-400' :
                  mensagemTipo === 'err' ? 'text-red-700 dark:text-red-400' :
                                           'text-blue-700 dark:text-blue-400'">
      {{ mensagemTipo === 'ok' ? 'Sucesso' : mensagemTipo === 'err' ? 'Não foi possível concluir' : 'Aviso' }}
    </p>
    <p class="text-xs text-gray-600 dark:text-gray-300 mt-0.5">{{ mensagem }}</p>
  </div>

  <button (click)="mensagem = null" title="Fechar"
          class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 flex-shrink-0">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </button>
</div>
